/* eslint-disable react/jsx-props-no-spreading */
import { ButtonHTMLAttributes, ReactElement } from 'react';

import { Button } from './styles';

interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  icon?: ReactElement;
  iconPosition?: 'left' | 'right';
  iconWhiteBackground?: boolean;
  iconBorderRadius?: boolean;
}

export const StyledButton: React.FC<IProps> = ({
  text,
  icon,
  iconPosition,
  iconWhiteBackground = false,
  color,
  iconBorderRadius = false,
  disabled = false,
  ...rest
}) => (
  <Button
    svgRadius={iconBorderRadius}
    svgWhiteBackground={iconWhiteBackground}
    disabled={disabled}
    color={color}
    {...rest}
  >
    {iconPosition === 'left' && icon}
    {text}
    {iconPosition === 'right' && icon}
  </Button>
);
